console.log('✅ SHRINE GIFT SYNC CARGADO');
(() => {
  const STORAGE_KEY = 'shrine_quantity_gift_rules_v1';

  let syncing = false;

  function readRulesFromPage() {
    const components = document.querySelectorAll('quantity-gifts');

    if (!components.length) return;

    const storedRules = getStoredRules();

    components.forEach(component => {
      const mainProductHandle = component.dataset.mainProduct;

      if (!mainProductHandle) return;

      const gifts = [];

      component.querySelectorAll('.quantity-gift').forEach(gift => {
        const variantId = Number(gift.dataset.product);
        const requiredQuantity = Number(gift.dataset.quantity);

        if (!variantId || !requiredQuantity) return;

        gifts.push({
          variantId,
          requiredQuantity
        });
      });

      if (!gifts.length) return;

      storedRules[mainProductHandle] = {
        mainProductHandle,
        gifts
      };
    });

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(storedRules)
    );
  }

  function getStoredRules() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('No se pudo leer el carrito');
    }

    return response.json();
  }

  function calculateAllowedGifts(cart, rule) {
    const mainQuantity = cart.items
      .filter(item => item.handle === rule.mainProductHandle)
      .reduce((total, item) => total + item.quantity, 0);

    const allowed = {};

    rule.gifts.forEach(gift => {
      if (mainQuantity >= gift.requiredQuantity) {
        allowed[gift.variantId] =
          (allowed[gift.variantId] || 0) + 1;
      }
    });

    return allowed;
  }

  async function syncQuantityGifts() {
    if (syncing) return;

    syncing = true;

    try {
      readRulesFromPage();

      const rules = getStoredRules();

      if (!Object.keys(rules).length) return;

      const cart = await getCart();

      const giftVariantIds = new Set();

      Object.values(rules).forEach(rule => {
        rule.gifts.forEach(gift => {
          giftVariantIds.add(Number(gift.variantId));
        });
      });

      const totalAllowed = {};

      Object.values(rules).forEach(rule => {
        const allowed = calculateAllowedGifts(cart, rule);

        Object.entries(allowed).forEach(([variantId, qty]) => {
          totalAllowed[variantId] =
            (totalAllowed[variantId] || 0) + qty;
        });
      });

      const updates = {};
      let needsUpdate = false;

      cart.items.forEach(item => {
        const variantId = Number(item.variant_id);

        if (!giftVariantIds.has(variantId)) return;

        const allowedQuantity =
          totalAllowed[variantId] || 0;

        if (item.quantity > allowedQuantity) {
          updates[item.key] = allowedQuantity;
          needsUpdate = true;
        }
      });

      if (!needsUpdate) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          updates
        })
      });

      document.dispatchEvent(
        new CustomEvent('shrineGiftSyncCompleted')
      );

      window.location.reload();

    } catch (error) {
      console.error(
        '[Shrine Gift Sync]',
        error
      );
    } finally {
      syncing = false;
    }
  }

  /*
   * Shrine dispara este evento después
   * de modificar cantidades/eliminar items.
   */
  document.addEventListener(
    'cartQuantityUpdated',
    () => {
      setTimeout(syncQuantityGifts, 100);
    }
  );

  /*
   * Guardamos las reglas de Shrine
   * cuando estamos en la página del producto.
   */
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      readRulesFromPage();
    }
  );

  /*
   * Protección adicional antes de checkout.
   */
  document.addEventListener(
    'click',
    async event => {
      const checkout = event.target.closest(
        'button[name="checkout"], ' +
        'input[name="checkout"], ' +
        'a[href="/checkout"]'
      );

      if (!checkout) return;

      event.preventDefault();

      await syncQuantityGifts();

      window.location.href = '/checkout';
    },
    true
  );
})();